import * as Yup from 'yup';
import { URL_REGEX } from '../../shared/utils/regex';

const useAddTrackedLink = () => {
  const AddTrackedLinkValidationSchema = Yup.object().shape({
    domain_id: Yup.string().required('Please select a Domain Name'),
    slash_tag: Yup.string().when(
      'is_custom_slash_tag_link',
      ([isCustomSlashTag], schema) => {
        if (isCustomSlashTag) return schema.required('Please enter a slash Tag');
        return schema;
      }
    ),
    destination_url: Yup.string()
      .required('Please enter a valid Destination URL')
      .matches(URL_REGEX, 'Please enter a valid Destination URL'),
  });
  return {
    AddTrackedLinkValidationSchema,
  };
};

export default useAddTrackedLink;
